export function openFrontChatPopup() {
  if (typeof window.FrontChat === 'function') {
    try {
      window.FrontChat('show');
    } catch (error) {
      console.warn('Failed to open Front chat:', error);
    }
  } else {
    console.warn('Front chat not loaded yet');
  }
}
